import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';
import { FormField, TabsTimelineSub, Upload } from 'components';
import { isAuditor, isAuditorFinal, isCommittee, isCommitteeFinal, isInvestor, isObjection, isObjectionCommittee, isObjectionCommitteeFinal, isDocumentsUpload, isOperator, isCommitteeAfterOperations, isCommitteeAfterOperationsFinal, isObjectionDocuments, isObjectionDocumentsCommittee, isObjectionDocumentsCommitteeFinal, isBeneficiary } from 'utils';
import { DownloadedItems } from './components/index';
import { flattenDocs } from './utils';
import DocsEquipmentSupplier from './components/docsEquipmentSupplier';
import { isEmpty, omit } from 'lodash';
import { Col, Empty, Form, Row } from 'antd';
import { content} from './components/docsEquipmentSupplier/content';
import { useForm } from 'antd/lib/form/Form';

const DocumentsEquipmentSupplier = () => {

  const docs = useSelector(state => state.forms.documents);
  const activeTaskName = useSelector(state => state.forms.activeTaskName);
  const flatDocs = flattenDocs(docs);
  const user = useSelector(state => state.user);
  const supEquipmentDoc = useSelector(state => state.forms.documents.supEquipmentDoc);
  const supCertEquipmentDoc = useSelector(state => state.forms.documents.supCertEquipmentDoc);
  const returnAuditorMessage = useSelector(state => state.forms.auditor.returnAuditorMessage);
  const isViewMode = useSelector(state => state.forms.carrier.viewMode);
  const viewMode = isViewMode || 
                  !isBeneficiary(user.groups) || 
                  activeTaskName === "task.name.temporary_rejected" ||
                  activeTaskName === "task.name.accepted";

  return !viewMode ? (
    <div>
      <div className="mt-6"/>
      <DocsEquipmentSupplier group={'documents'} />
      {(isBeneficiary(user.groups) && activeTaskName === 'task.name.application_returned_to_supplier' && !viewMode) &&
                <div className='mt-5'>
                  <Col className="gutter-row" span={12}>
                      <FormField
                        label={'Σχόλιο Αξιολογητή'}
                        type='textarea'
                        disabled={true}
                        rows={6}
                        bold={true}
                        value={returnAuditorMessage}
                      />
                  </Col>
                </div>
              }
      <div/>
    </div>
  ) 
    :
    (
    <div style={{minHeight:"500px"}}  >
      <div className="mt-4"/>
      {/* <DownloadedItems content={content_onlyNP} docs={flatDocs} />
      <DownloadedItems content={content_existCon} docs={flatDocs} /> */}
      {
        isEmpty(supEquipmentDoc) && isEmpty(supCertEquipmentDoc) ?
        <div style={{position:"absolute", top:"10%", left:"50%"}}>
          <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} description={<>No data</>} />
        </div>
        :
        <>
          <DownloadedItems content={content()} docs={flatDocs} />
          {returnAuditorMessage && 
            <Col className="gutter-row mt-3" span={12}>
              <FormField
                label={'Σχόλιο Αξιολογητή'}
                type='textarea'
                disabled={true}
                rows={6}
                bold={true}
                value={returnAuditorMessage}
              />
            </Col>}
        </>
      }
    </div>
  );
};

DocumentsEquipmentSupplier.propTypes = {
  group: PropTypes.string.isRequired,
};

export default DocumentsEquipmentSupplier;
